import React from "react";
import LazyMedia from "./LazyMedia";
import PromoInfo from "./PromoInfo"; // PromoInfo 추가
import "./ProductCard.css";
import { Icon } from "@iconify/react";
const ProductCard = ({
  product,
  onTagClick,
  selectedTag,
  selectedCategory1,
  selectedCategory2,
  selectedCategory3
}) => {
  const handleCardClick = () => {
    if (product.promotion_link) {
      window.open(product.promotion_link, "_blank");
    }
  };

  const originalPrice = parseFloat(product.target_original_price) || 0;
  const salePrice = parseFloat(product.target_sale_price) || 0;
  const revenue = parseFloat(product.revenue) || 0;
  const discount =
    originalPrice > 0
      ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
      : 0;
  const hasDiscount = discount > 0;

  const category1 = product.first_level_category_name;
  const category2 = product.second_level_category_name;
  const category3Keywords = product.keywords ? product.keywords.split(",") : [];

  // 해시태그 전체 (카테고리1, 카테고리2, 키워드들)
  const hashtags = [category1, category2, ...category3Keywords].filter(Boolean);

  const handleTagClick = (e, tag) => {
    e.stopPropagation();
    if (tag === category1) {
      onTagClick(tag, "c1");
    } else if (tag === category2) {
      onTagClick(tag, "c2");
    } else {
      onTagClick(tag, "c3");
    }
  };

  return (
    <div
      className="product-card"
      onClick={handleCardClick}
      style={{ cursor: "pointer", position: "relative" }}
    >
      {/* 한국 배송 배지 */}
      {product.original_price_currency === "KRW" && (
        <div className="korean-product-badge">한국 배송</div>
      )}

      <LazyMedia
        src={product.product_main_image_url}
        alt={product.product_title}
        className="product-image"
      />

      {/* 프로모션 정보 추가 */}
      {product.promo_code_info && product.promo_code_info !== "nan" && (
        <PromoInfo promoInfo={product.promo_code_info} salePrice={salePrice} />
      )}


      <p className="product-price">
        {hasDiscount && (
          <span className="original-price">
            {originalPrice.toLocaleString()}원
          </span>
        )}
        <span className="sale-price">{salePrice.toLocaleString()}원</span>
        {hasDiscount && <span className="discount-badge">🔥 {discount}%</span>}
      </p>

      {product.lastest_volume > 0 && (
        <p className="sales-volume">
          📦 {product.lastest_volume.toLocaleString()}개 판매 (
          {revenue.toLocaleString()}원)
        </p>
      )}

      <h3 className="product-name">{product.product_title}</h3>

      <div className="product-hashtags">
        {hashtags.map((tag, index) => {
          const isSelected =
            tag === selectedTag ||
            tag === selectedCategory1 ||
            tag === selectedCategory2 ||
            tag === selectedCategory3;

          return (
            <button
              key={index}
              className={`hashtag ${isSelected ? "selected" : ""}`}
              onClick={(event) => handleTagClick(event, tag)}
            >
              #{tag}{" "}
              {isSelected && (
                <Icon 
                  icon="material-symbols:close"
                  inline={true}
                  style={{ fontSize: "0.8rem", color: "#999", cursor: "pointer" }}
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(ProductCard);
